module.exports = __webpack_public_path__ + "img/tutor-list-header.ecb54e1.webp";